import { render, staticRenderFns } from "./Calls.vue?vue&type=template&id=1627a58b&scoped=true&"
import script from "./Calls.vue?vue&type=script&lang=ts&"
export * from "./Calls.vue?vue&type=script&lang=ts&"
var disposed = false

function injectStyles (context) {
  if (disposed) return
  var style0 = require("./Calls.vue?vue&type=style&index=0&id=1627a58b&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1627a58b",
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/actions-runner/_work/mfe-ca-tester/mfe-ca-tester/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1627a58b')) {
      api.createRecord('1627a58b', component.options)
    } else {
      api.reload('1627a58b', component.options)
    }
    module.hot.accept("./Calls.vue?vue&type=template&id=1627a58b&scoped=true&", function () {
      api.rerender('1627a58b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Calls.vue"
export default component.exports